<template>
  <div
    v-if="visible"
    :key="animationKey"
    class="shortlist-notification"
    :class="{
      'shortlist-notification--expanded': expanded,
      'shortlist-notification--exiting': exiting,
      'shortlist-notification--removed': removed,
    }"
    role="status"
    aria-live="polite"
  >
    <div class="shortlist-notification__heart" aria-hidden="true">
      <svg
        v-if="removed"
        class="shortlist-notification__heart-removed"
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M27.875 7.12502C26.5164 5.76984 24.6765 5.00775 22.7576 5.00541C20.8387 5.00307 18.9969 5.76066 17.635 7.11252L16 8.63127L14.3637 7.10752C13.0022 5.74978 11.157 4.98852 9.23421 4.99122C7.31137 4.99391 5.46837 5.76034 4.11062 7.1219C2.75288 8.48345 1.99162 10.3286 1.99432 12.2514C1.99702 14.1743 2.76344 16.0173 4.125 17.375L15.2937 28.7075C15.3868 28.802 15.4977 28.877 15.62 28.9283C15.7424 28.9795 15.8736 29.0058 16.0062 29.0058C16.1389 29.0058 16.2701 28.9795 16.3925 28.9283C16.5148 28.877 16.6257 28.802 16.7187 28.7075L27.875 17.375C29.2337 16.0155 29.997 14.1721 29.997 12.25C29.997 10.3279 29.2337 8.48454 27.875 7.12502ZM26.4562 15.97L16 26.575L5.5375 15.96C4.55288 14.9754 3.99973 13.64 3.99973 12.2475C3.99973 10.8551 4.55288 9.51964 5.5375 8.53502C6.52211 7.55041 7.85754 6.99725 9.25 6.99725C10.6425 6.99725 11.9779 7.55041 12.9625 8.53502L12.9875 8.56002L15.3187 10.7288C15.5038 10.901 15.7472 10.9967 16 10.9967C16.2528 10.9967 16.4962 10.901 16.6812 10.7288L19.0125 8.56002L19.0375 8.53502C20.0228 7.55107 21.3586 6.99882 22.751 6.99975C24.1435 7.00069 25.4785 7.55474 26.4625 8.54002C27.4465 9.5253 27.9987 10.8611 27.9978 12.2536C27.9968 13.646 27.4428 14.9811 26.4575 15.965L26.4562 15.97Z"
          fill="black"
        />
      </svg>
      <svg
        v-if="!removed"
        class="shortlist-notification__heart-added"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30 12.25C30.0021 13.2023 29.8154 14.1456 29.4507 15.0253C29.0859 15.9049 28.5504 16.7036 27.875 17.375L16.7125 28.7025C16.6194 28.797 16.5085 28.872 16.3862 28.9232C16.2639 28.9744 16.1326 29.0008 16 29.0008C15.8674 29.0008 15.7361 28.9744 15.6138 28.9232C15.4915 28.872 15.3805 28.797 15.2875 28.7025L4.125 17.375C2.76411 16.0157 1.99891 14.1716 1.99774 12.2481C1.99656 10.3247 2.75951 8.47961 4.11875 7.11872C5.47798 5.75783 7.32216 4.99263 9.24558 4.99146C11.169 4.99028 13.0141 5.75324 14.375 7.11247L16 8.63122L17.6362 7.10747C18.6518 6.09696 19.944 5.40998 21.3497 5.13326C22.7553 4.85654 24.2115 5.00249 25.5343 5.55269C26.8571 6.10288 27.9872 7.03265 28.782 8.22462C29.5768 9.41659 30.0006 10.8173 30 12.25Z"
          fill="#E7000B"
        />
      </svg>
    </div>

    <div class="shortlist-notification__content">
      <div class="shortlist-notification__copy">
        <p class="shortlist-notification__title">
          {{ title }}
        </p>
        <p class="shortlist-notification__description">
          {{ description }}
        </p>
      </div>

      <button
        v-if="removed && undoAction"
        type="button"
        class="shortlist-notification__link shortlist-notification__undo"
        :disabled="undoing"
        @click="handleUndo"
      >
        Undo
      </button>
      <a
        v-else-if="!removed"
        :href="shortlistUrl"
        class="shortlist-notification__link"
      >
        View list
      </a>
    </div>
  </div>
</template>

<script>
import {
  SHORTLIST_ADDED_EVENT,
  SHORTLIST_REMOVED_EVENT,
} from './shortlistNotification';

export default {
  name: 'ShortlistNotification',

  props: {
    open: {
      type: Boolean,
      default: false,
    },
    propertyAddress: {
      type: String,
      default: 'Property',
    },
    shortlistUrl: {
      type: String,
      default: '/student/shortlist',
    },
    duration: {
      type: Number,
      default: 4000,
    },
  },

  data() {
    return {
      animationKey: 0,
      expanded: false,
      eventAddress: null,
      exiting: false,
      expandTimer: null,
      hideTimer: null,
      removed: false,
      transitionTimer: null,
      undoAction: null,
      undoError: false,
      undoing: false,
      visible: false,
    };
  },

  computed: {
    address() {
      return this.eventAddress || this.propertyAddress || 'Property';
    },
    title() {
      return this.removed
        ? `Removed from ${this.address}`
        : `Saved to “${this.address}”`;
    },
    description() {
      if (this.undoError) return 'Could not restore property. Try again.';
      return this.removed
        ? 'Property removed from shortlist'
        : 'Property added to your new list';
    },
  },

  watch: {
    open: {
      immediate: true,
      handler(isOpen) {
        if (isOpen) {
          this.show();
          return;
        }

        this.hide();
      },
    },
  },

  mounted() {
    window.addEventListener(SHORTLIST_ADDED_EVENT, this.handleAddedEvent);
    window.addEventListener(SHORTLIST_REMOVED_EVENT, this.handleRemovedEvent);
  },

  beforeDestroy() {
    window.removeEventListener(SHORTLIST_ADDED_EVENT, this.handleAddedEvent);
    window.removeEventListener(
      SHORTLIST_REMOVED_EVENT,
      this.handleRemovedEvent
    );
    this.clearTimers();
  },

  methods: {
    clearTimers() {
      clearTimeout(this.expandTimer);
      clearTimeout(this.hideTimer);
      clearTimeout(this.transitionTimer);
    },
    handleAddedEvent(event) {
      this.eventAddress = event.detail?.address || 'Property';
      this.removed = false;
      this.undoAction = null;
      this.show();
    },
    handleRemovedEvent(event) {
      this.eventAddress = event.detail?.address || 'Property';
      this.removed = true;
      this.undoAction =
        typeof event.detail?.undo === 'function' ? event.detail.undo : null;
      this.show();
    },
    show() {
      this.clearTimers();
      this.animationKey += 1;
      this.undoError = false;
      this.undoing = false;
      this.expanded =
        window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ||
        false;
      this.exiting = false;
      this.visible = true;

      if (!this.expanded) {
        this.expandTimer = setTimeout(() => {
          this.expanded = true;
        }, 600);
      }

      this.hideTimer = setTimeout(() => {
        this.hide();
        this.$emit('close');
      }, this.duration);
    },
    async handleUndo() {
      if (!this.undoAction || this.undoing) return;

      const animationKey = this.animationKey;
      this.undoing = true;
      clearTimeout(this.hideTimer);

      try {
        const restored = await this.undoAction();
        if (animationKey !== this.animationKey) return;
        if (restored === false) throw new Error('Could not restore shortlist');
        this.hide();
      } catch {
        if (animationKey !== this.animationKey) return;
        this.undoError = true;
        this.hideTimer = setTimeout(() => this.hide(), this.duration);
      } finally {
        if (animationKey === this.animationKey) this.undoing = false;
      }
    },
    hide() {
      if (!this.visible) return;

      clearTimeout(this.expandTimer);
      clearTimeout(this.hideTimer);
      this.exiting = true;

      if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
        this.visible = false;
        return;
      }

      this.transitionTimer = setTimeout(() => {
        this.visible = false;
      }, 250);
    },
  },
};
</script>

<style scoped>
.shortlist-notification {
  position: fixed;
  bottom: 24px;
  left: 24px;
  z-index: 9999;
  display: flex;
  box-sizing: border-box;
  width: 66px;
  height: 66px;
  max-width: calc(100vw - 48px);
  padding: 16px;
  overflow: hidden;
  align-items: center;
  border: 1px solid #e5e7eb;
  border-radius: 33px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 10%);
  transition: width 350ms cubic-bezier(0.22, 1, 0.36, 1),
    border-radius 350ms ease, opacity 250ms ease;
}

.shortlist-notification--expanded {
  width: 400px;
  height: 66px;
  padding: 11px 16px;
  border-radius: 24px;
}

.shortlist-notification--exiting {
  opacity: 0;
  pointer-events: none;
}

.shortlist-notification__heart {
  display: flex;
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  aspect-ratio: 1 / 1;
  align-items: center;
  justify-content: center;
  animation: shortlist-heart-grow 350ms ease-out both;
}

.shortlist-notification__heart-added,
.shortlist-notification__heart-removed {
  width: 32px;
  height: 32px;
  aspect-ratio: 1 / 1;
}

@keyframes shortlist-heart-grow {
  from {
    opacity: 0;
    transform: translateX(8px) rotate(-40deg) scale(0.35);
  }

  70% {
    opacity: 1;
    transform: translateX(-1px) rotate(6deg) scale(1.15);
  }

  to {
    opacity: 1;
    transform: translateX(0) rotate(0) scale(1);
  }
}

.shortlist-notification__content {
  display: flex;
  min-width: 313px;
  margin-left: 16px;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  opacity: 0;
  transform: translateX(-8px);
  pointer-events: none;
  transition: opacity 180ms ease 200ms, transform 180ms ease 200ms;
}

.shortlist-notification--expanded .shortlist-notification__content {
  opacity: 1;
  pointer-events: auto;
  transform: translateX(0);
}

.shortlist-notification__copy {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
}

.shortlist-notification__title,
.shortlist-notification__description {
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.shortlist-notification__title {
  color: #374151;
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
}

.shortlist-notification__description {
  color: #6b7280;
  font-size: 12px;
  line-height: 21px;
}

.shortlist-notification__link {
  flex: 0 0 auto;
  color: #00628f;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  white-space: nowrap;
}

.shortlist-notification__undo {
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  font-family: inherit;
}

.shortlist-notification__undo:disabled {
  cursor: wait;
  opacity: 0.6;
}

@media (max-width: 479px) {
  .shortlist-notification {
    bottom: 16px;
    left: 16px;
    width: 66px;
    height: 66px;
    max-width: calc(100vw - 32px);
    border-radius: 33px;
  }

  .shortlist-notification--expanded {
    width: 343px;
    height: 66px;
    padding: 16px;
    border-radius: 24px;
  }

  .shortlist-notification__content {
    width: min(261px, calc(100vw - 114px));
    min-width: 0;
    flex: 0 0 auto;
    margin-left: 16px;
  }

  .shortlist-notification__description {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .shortlist-notification,
  .shortlist-notification__content {
    transition: none;
  }

  .shortlist-notification__heart {
    animation: none;
  }
}
</style>
